import React, {
    Component,
    PureComponent
} from 'react'

import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';


export default class InputClickEditable extends Component {
    constructor() {
        super()
        this.state = {
            editing: false,
            value: ''
        }
    }

    componentDidMount() {
        this.setState({
            value: this.props.value,
            editing: !this.props.value ? true : false,
        })
    }

    handleSubmit() {
        this.props.onChange(this.state.value);
        this.setState({
            editing: false,
        })
    }

    cancel(e) {
        e.stopPropagation();
        this.setState({
            editing: !this.props.value ? true : false,
            value: this.props.value
        })
    }

    render() {
        return (
            <div className="input-click-editable">
                {this.state.editing && !this.props.readonly ? (
                    <Input
                        autoFocus
                        onKeyDown={e=>{
                            if(e.key === 'Enter'){
                                this.handleSubmit();
                            }else if(e.key === 'Escape'){
                                this.cancel();
                            }
                        }}
                        className="input"
                        name="accidentNumber"
                        type={'text'}
                        classes={{root: 'input-root'}}
                        value={this.state.value}
                        onChange={(e)=>{this.setState({value: e.target.value})}}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="Cancel editing"
                                    onClick={this.cancel.bind(this)}
                                >
                                  <CancelIcon/>
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                ) : (
                    <div className="label" onClick={e=>{
                        e.stopPropagation();
                        this.setState({editing: true});
                    }}>
                        {this.state.value}
                    </div>
                )}
            </div>
        )
    }
}
